import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

interface InputFieldProps extends React.ComponentProps<"input"> {
  label?: string;
  required?: boolean;
  error?: string;
}

export function InputField({
  label,
  required,
  error,
  className,
  ...props
}: InputFieldProps) {
  return (
    <div className="flex flex-col gap-2">
      {label && (
        <Label className="text-xs font-bold tracking-wide text-field">
          {label} {required && <span className="text-destructive">*</span>}
        </Label>
      )}
      <Input className={cn(className)} {...props} />
      {error && <p className="text-xs text-destructive">{error}</p>}
    </div>
  );
}
